import { usePathname } from 'expo-router';

type VaroOnboardingFlow =
  | 'onboarding'
  | 'believe-funding'
  | 'move-money'
  | 'progress-tracker-funding';

const useVaroOnboardingFlow = (): VaroOnboardingFlow => {
  const pathname = usePathname();
  let flow: VaroOnboardingFlow = 'move-money';
  if (pathname.startsWith('/onboarding')) {
    flow = 'onboarding';
  } else if (pathname.startsWith('/believe-funding')) {
    flow = 'believe-funding';
  } else if (pathname.startsWith('/progress-tracker-funding')) {
    flow = 'progress-tracker-funding';
  }
  return flow;
};

export default useVaroOnboardingFlow;
